import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Button,
  Grid,
  Col,
} from 'antd';

const FormSubmitCustomControls = ({
  controls,
  loading,
  label,
  labelSpan,
  controlsSpan,
}) => {
  const screens = Grid.useBreakpoint();
  const ControlsWrapper = controlsSpan === 24 ? Row : Col;
  const controlsWrapperProps = controlsSpan === 24
    ? { justify: 'end', style: { width: '100%' } }
    : { span: controlsSpan };

  return (
    <Row justify="space-between">
      <Col span={labelSpan}>
        {label}
      </Col>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <ControlsWrapper {...controlsWrapperProps}>
        {controls.filter((e) => e).map(({
          icon,
          key,
          onClick,
          disabled,
          text,
          rigthIcon,
          ...btnProps
        }, idx) => (
          btnProps && (
            <Button
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...btnProps}
              type="link"
              onClick={onClick}
              key={key || idx}
              disabled={loading || disabled}
            >
              {!!icon && icon}
              {screens.md && (text)}
              {!!rigthIcon && rigthIcon}
            </Button>
          )
        ))}
      </ControlsWrapper>
    </Row>
  );
};

FormSubmitCustomControls.propTypes = {
  controls: PropTypes.arrayOf(PropTypes.shape({
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    icon: PropTypes.node,
    rigthIcon: PropTypes.node,
  })).isRequired,
  loading: PropTypes.bool,
  label: PropTypes.string,
  labelSpan: PropTypes.number,
  controlsSpan: PropTypes.number,
};

FormSubmitCustomControls.defaultProps = {
  loading: false,
  label: null,
  labelSpan: null,
  controlsSpan: null,
};

export default FormSubmitCustomControls;
